export const matchesCategory = (tags, category) => category === 'all' || String(tags).split(/\s+/).includes(category);

export function filterState(tags, category) {
  const visible = tags.map(value => matchesCategory(value, category));
  return { visible, count: visible.filter(Boolean).length };
}

const mounted = new WeakMap();

export function destroyProjects(scope) {
  mounted.get(scope)?.();
  mounted.delete(scope);
}

export function mountProjects(scope) {
  if (mounted.has(scope)) return;
  const controls = scope.querySelector('[data-srs-filters]');
  if (!controls) return;
  const buttons = [...controls.querySelectorAll('[data-srs-filter]')];
  if (!buttons.length) return;
  const cards = [...scope.querySelectorAll('[data-srs-project]')];
  const empty = scope.querySelector('[data-srs-empty]');
  const status = scope.querySelector('[data-srs-count]');
  const controller = new AbortController();
  const { signal } = controller;
  const apply = category => {
    const state = filterState(cards.map(card => card.dataset.tags), category);
    cards.forEach((card, index) => { card.hidden = !state.visible[index]; });
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.srsFilter === category)));
    if (empty) empty.hidden = state.count !== 0;
    if (status) status.textContent = state.count === 1 ? scope.dataset.one : scope.dataset.many?.replace('%count%', String(state.count)) ?? String(state.count);
  };
  controls.addEventListener('click', event => {
    const button = event.target.closest?.('[data-srs-filter]');
    if (button && controls.contains(button)) apply(button.dataset.srsFilter);
  }, { signal });
  controls.addEventListener('keydown', event => {
    const button = event.target.closest?.('[data-srs-filter]');
    const index = buttons.indexOf(button);
    if (index < 0) return;
    let next;
    if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
    else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;
    event.preventDefault();
    buttons[next].focus();
  }, { signal });
  controls.hidden = false;
  apply('all');
  mounted.set(scope, () => {
    controller.abort();
    apply('all');
    controls.hidden = true;
    if (empty) empty.hidden = true;
  });
}

const scopes = target => [...(target.matches?.('[data-srs-projects]') ? [target] : []), ...target.querySelectorAll('[data-srs-projects]')];
if (typeof document !== 'undefined') {
  scopes(document).forEach(mountProjects);
  document.addEventListener('shopify:section:load', event => scopes(event.target).forEach(mountProjects));
  document.addEventListener('shopify:section:unload', event => scopes(event.target).forEach(destroyProjects));
}
